module.exports = __webpack_public_path__ + "img/upload-another.ff5038ca.svg";